export const publicpath = process.env.PUBLIC_URL;
